import React from "react";
import PropTypes from "prop-types";
import { Typography, Box } from "@mui/material";
import WarningRoundedIcon from "@mui/icons-material/WarningRounded";
import StyledTooltip from "../StyledTooltip/StyledTooltip";

export default function WarningMessage({ text, displayText }) {
  return (
    <StyledTooltip title={!displayText ? text : ""}>
      <Box sx={{ display: "flex", alignItems: "center" }}>
        <WarningRoundedIcon sx={{ color: "error.60", fontSize: "18px", marginRight: "6px" }} />
        {displayText &&
          <Typography variant="body1" color="error.60" sx={{ marginTop: "2px", whiteSpace: "pre-wrap" }}>
            {text}
          </Typography>
        }
      </Box>
    </StyledTooltip>
  );
}

WarningMessage.propTypes = {
  text: PropTypes.string.isRequired,
  displayText: PropTypes.string
};